export default "__VITE_PUBLIC_ASSET__2567f0eb__"